import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Calendar, ArrowRight } from "react-feather";
import EmptyState from "../../../common/EmptyState";
import "./monthly-invoice.css";

const monthOrder = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const monthSortKey = (month) => {
  const [name, year] = (month || "").split(",");
  return parseInt(year || 0) * 100 + monthOrder.indexOf(name);
};

// Same calendar-page cards as the invoice months (styles: wholesale-kido.css).
// Each month keeps its own colour, year after year.
const TONES = ["sky", "mint", "butter", "peach", "lilac", "sky", "mint", "butter", "peach", "lilac", "sky", "mint"];

const formatTk = (value) =>
  `৳ ${Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const STATS = [
  { key: "totalBill", label: "Total bill", mod: "lead" },
  { key: "totalPaid", label: "Total paid" },
  { key: "totalBuyingCost", label: "Total buying cost" },
  { key: "totalZapaiProfit", label: "KIDO profit", mod: "accent" },
  { key: "totalAgentProfit", label: "Agent profit" },
  { key: "totalProfit", label: "Total profit" },
  { key: "totalRefundGiven", label: "Refund given", mod: "refund" },
  { key: "totalRefundTaken", label: "Refund taken", mod: "refund-taken" },
];

export class Datatable extends Component {
  render() {
    const { myData, history, currentMonth, agent } = this.props;
    const months = [...(myData || [])].sort(
      (a, b) => monthSortKey(b.month) - monthSortKey(a.month),
    );

    return (
      <Fragment>
        {months.length === 0 ? (
          <div className="consultancy-month-empty">
            <EmptyState>No months found for this agent.</EmptyState>
          </div>
        ) : (
          <div className="consultancy-month-list">
            {months.map((month, i) => {
              const [name, year] = (month.month || "").split(",");
              const tone = TONES[monthOrder.indexOf(name)] || "sky";
              const open = () =>
                history.push(
                  `/business-consultancy/sourcing/agents/${agent}/${month.month}`,
                );
              return (
                <div
                  className={`consultancy-month-card kd-st--${tone}`}
                  key={month.month}
                  style={{ "--i": Math.min(i, 12) }}
                  role="link"
                  tabIndex={0}
                  onClick={open}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") open();
                  }}
                >
                  <div className="consultancy-month-card-header">
                    <div className="consultancy-month-card-title">
                      <Calendar size={20} aria-hidden="true" />
                      <span>{name}</span>
                      <small>{year}</small>
                    </div>
                    <div className="consultancy-month-card-header-right">
                      {month.month === currentMonth && (
                        <span className="consultancy-month-card-badge is-now">
                          This month
                        </span>
                      )}
                      <span className="consultancy-month-card-badge">
                        {month.invoiceCount || 0} invoice
                        {month.invoiceCount === 1 ? "" : "s"}
                      </span>
                      <button
                        type="button"
                        className="consultancy-month-card-view"
                        tabIndex={-1}
                        onClick={(e) => {
                          e.stopPropagation();
                          open();
                        }}
                      >
                        View <ArrowRight size={14} aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                  <div className="consultancy-month-card-stats">
                    {STATS.map(({ key, label, mod }) => (
                      <div
                        key={key}
                        className={
                          "consultancy-month-stat" +
                          (mod ? ` consultancy-month-stat--${mod}` : "")
                        }
                      >
                        <span className="consultancy-month-stat-label">{label}</span>
                        <span className="consultancy-month-stat-value">
                          {formatTk(month[key])}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Fragment>
    );
  }
}

export default connect(null, {})(Datatable);
